import { z } from 'zod'

export const paramsSchema = z.object({
  facetSlug: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
